(() => {
  const normalize = (value) => String(value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

  const bindSearchInput = (input) => {
    if (!input || input.dataset.jd1Bound === 'true') return;
    input.dataset.jd1Bound = 'true';

    const run = () => {
      const targetId = input.dataset.target;
      const list = targetId ? document.getElementById(targetId) : input.closest('[data-jd1-filter-search]')?.nextElementSibling?.querySelector('ul');
      if (!list) return;

      const term = normalize(input.value);
      const items = Array.from(list.querySelectorAll('[data-jd1-filter-value]'));
      items.forEach((item) => {
        const label = normalize(item.dataset.jd1FilterValue);
        item.classList.toggle('jd1-filter-value--hidden', Boolean(term) && !label.includes(term));
      });
    };

    input.addEventListener('input', run);
    input.addEventListener('search', run);
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-jd1-filter-search-input]').forEach(bindSearchInput);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => init(event.target));
  document.addEventListener('results-list:updated', () => init());
  document.addEventListener('facet:update', () => init());
})();